import {changeEvent, documentLoadEvent, fireChangeEvent} from "../../../../../webpack/modules/events";
import {initTomSelectQuantity} from "../../../../../webpack/modules-optimized/tomselect";
import {updatePriceElements} from "../../../../../webpack/modules-optimized/product-page";

documentLoadEvent(function() {
    initTomSelectQuantities();
});

changeEvent('#product-page .option-single-value input[name="size"]', false, function(element) {
    let container = element.closest('.product-scope');
    let option = element.closest('.option-single-value');
    let quantity = option.querySelector('.quantity-selector');

    if (!quantity.classList.contains('quantity-add-to-cart')) quantity.classList.add('quantity-add-to-cart');
    updatePriceElements(container);
});

function initTomSelectQuantities()
{
    document.querySelectorAll('#product-page .option-single-value .select-quantity').forEach(function(quantity) {
        let tomSelect = initTomSelectQuantity(quantity);

        tomSelect.on('dropdown_close', function () {
            let wrapper = tomSelect.wrapper;
            let input = wrapper.closest('.option-single-value').querySelector('input[name="size"]');
            let quantity = tomSelect.getValue();

            if (!input) return;

            input.dataset.quantity = quantity;
            input.checked = quantity > 0;
            fireChangeEvent(input);
        });
    });
}